import { AdapterUi } from "@core/store/adapters/global.adapter";
import { User, UserForm } from "@modules/users/entities";
import { createAction, props } from "@ngrx/store";

export enum UsersAction {
  ClearAll = "[USERS] Clear All Users",
  UiUsers = "[USERS] UI Users",
  Empty = "[USERS] Empty",
  FetchUsers = "[USERS] Fetch Users",
  FetchUserById = "[USERS] Fetch User by Id",
  SetUsers = "[USERS] Set Users",
  SetSelectedUser = "[USERS] Set Selected User",
  ModifySelectedRetailers = "[USERS] Modify Selected Retailers",
  CreateUser = "[USERS] Create User",
  UpdateUser = "[USERS] Update User",
  UpdateUserStatus = "[USERS] Update User Status",
  DeleteUser = "[USERS] Delete User",
}

export const clearAll = createAction(UsersAction.ClearAll);
export const uiUsers = createAction(UsersAction.UiUsers, props<{ ui: Array<AdapterUi> }>());
export const Empty = createAction(UsersAction.Empty);

export const fetchUsers = createAction(UsersAction.FetchUsers);
export const fetchUserById = createAction(UsersAction.FetchUserById, props<{ payload: number }>());
export const setUsers = createAction(UsersAction.SetUsers, props<{ payload: User[] }>());
export const setSelectedUser = createAction(UsersAction.SetSelectedUser, props<{ payload: UserForm }>());
export const createUser = createAction(UsersAction.CreateUser, props<{ payload: UserForm }>());
export const updateUserStatus = createAction(UsersAction.UpdateUserStatus, props<{ payload: Partial<UserForm> }>());
export const updateUser = createAction(UsersAction.UpdateUser, props<{ payload: UserForm }>());
export const modifySelectedRetailers = createAction(UsersAction.ModifySelectedRetailers, props<{ payload: number[] }>());
export const deleteUser = createAction(UsersAction.DeleteUser, props<{ id: number }>());
